import { render, staticRenderFns } from "./categoryDialog.vue?vue&type=template&id=c1d71bc6&scoped=true"
import script from "./categoryDialog.vue?vue&type=script&lang=js"
export * from "./categoryDialog.vue?vue&type=script&lang=js"
import style0 from "./categoryDialog.vue?vue&type=style&index=0&id=c1d71bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d71bc6",
  null
  
)

export default component.exports